<nz-layout class="height-full">
    <nz-sider nzTheme="light" nzWidth="351px">
        <div class="am-dash-sider-container">
            <div class="am-dash-filter-panel am-dash-sider-content">
                <app-saved-dashboard-view></app-saved-dashboard-view>
                <div *ngFor="let link of [modify_time_users_datasource]">
                    <app-data-text
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-data-text>
                </div>
                <!-- Active Day / Install Day toggle -->
                <app-toggle [option]="settingDayMode.options"></app-toggle>
                <!-- User type visibility checkboxes -->
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    "
                >
                    <!-- <app-checkbox
                        [option]="settingShowAllUsers.options"
                    ></app-checkbox>
                    <app-checkbox
                        [option]="settingShowMetaUsers.options"
                    ></app-checkbox>
                    <app-checkbox
                        [option]="settingShowHopaUsers.options"
                    ></app-checkbox>
                    <app-checkbox
                        [option]="settingShowMetaProductiveUsers.options"
                    ></app-checkbox>
                    <app-checkbox
                        [option]="settingShowCoreLoopUsers.options"
                    ></app-checkbox> -->
                </div>
                <div *ngFor="let link of values(filterDashboardItemLinks)">
                    <!-- TODO Handle the remaining types -->
                    <app-category-filter-dashboard-item
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'CategoryFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                    </app-category-filter-dashboard-item>
                    <app-date-picker
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'DateRangeFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    >
                        ></app-date-picker
                    >
                    <app-segment-filter
                        *ngIf="
                            link.dashboardItemFactory.componentClass ==
                            'SegmentsFilterDashboardItem'
                        "
                        [dashboardItemFactory]="link.dashboardItemFactory"
                        [dataLoaderEmitter]="link.dataLoaderEmitter"
                    ></app-segment-filter>
                </div>
            </div>
            <div class="am-dash-sider-footer">
                <div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            nzType="primary"
                            (click)="applyChangedFilters()"
                            [disabled]="isApplyButtonDisabled"
                            style="flex-grow: 1"
                        >
                            Apply
                        </button>
                    </div>
                    <div class="am-dash-filter-footer-content">
                        <button
                            nz-button
                            color="primary"
                            (click)="standardDashboardInitialize()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Restore defaults
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="reloadData()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Reload data
                        </button>
                        <button
                            nz-button
                            color="primary"
                            (click)="requestNewSegmentsProcessing()"
                            nzSize="small"
                            style="flex-grow: 1"
                        >
                            Process new Segments
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </nz-sider>
    <nz-content class="am-dash-main-content">
        <div class="am-dash-legend-card">
            <div nz-row [nzGutter]="5">
                <div nz-col nzSpan="24">
                    <app-common-legend></app-common-legend>
                </div>
            </div>
        </div>
        <div class="main-container">
            <div class="grid-container">
                <nz-collapse>
                    <!-- ENERGY -->
                    <nz-collapse-panel
                        nzHeader="Energy"
                        [nzActive]="!isSectionCollapsed('energy')"
                        (nzActiveChange)="
                            onSectionActiveChange('energy', $event)
                        "
                    >
                        <nz-collapse>
                            <nz-collapse-panel
                                [nzHeader]="'Energy inflow'"
                                [nzActive]="
                                    !isSectionCollapsed('energy.inflow')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'energy.inflow',
                                        $event
                                    )
                                "
                            >
                                <p class="section-description">
                                    This section lets you monitor energy supply
                                    – how much energy reaches players and how
                                    that inflow changes over time, both
                                    calendar-wise and relative to the player's
                                    lifecycle day.
                                </p>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [energy_inflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                energy_inflow_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_energy_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_energy_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_energy_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_energy_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_energy_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Energy outflow'"
                                [nzActive]="
                                    !isSectionCollapsed('energy.outflow')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'energy.outflow',
                                        $event
                                    )
                                "
                            >
                                <p class="section-description">
                                    This section lets you monitor energy demand
                                    – how much energy players spend and how that
                                    consumption changes over time, both
                                    calendar-wise and relative to the player's
                                    lifecycle day.
                                </p>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [energy_outflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                energy_outflow_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_energy_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_energy_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_energy_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_energy_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_energy_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Energy balance'"
                                [nzActive]="
                                    !isSectionCollapsed('energy.balance')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'energy.balance',
                                        $event
                                    )
                                "
                            >
                                <p class="section-description">
                                    This section shows the energy balance
                                    (inflow minus outflow) – whether players
                                    accumulate or deplete energy and how that
                                    balance changes over time.
                                </p>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [energy_balance]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                energy_balance_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_energy_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_energy_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_energy_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_energy_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_energy_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                        </nz-collapse>
                    </nz-collapse-panel>

                    <!-- GEMS -->
                    <nz-collapse-panel
                        nzHeader="Gems"
                        [nzActive]="!isSectionCollapsed('gems')"
                        (nzActiveChange)="onSectionActiveChange('gems', $event)"
                    >
                        <nz-collapse>
                            <nz-collapse-panel
                                [nzHeader]="'Gems inflow'"
                                [nzActive]="!isSectionCollapsed('gems.inflow')"
                                (nzActiveChange)="
                                    onSectionActiveChange('gems.inflow', $event)
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [gems_inflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [gems_inflow_by_day_no]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_gems_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_gems_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_gems_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_gems_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_gems_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Gems outflow'"
                                [nzActive]="!isSectionCollapsed('gems.outflow')"
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'gems.outflow',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [gems_outflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [gems_outflow_by_day_no]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_gems_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_gems_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_gems_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_gems_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_gems_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Gems balance'"
                                [nzActive]="!isSectionCollapsed('gems.balance')"
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'gems.balance',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [gems_balance]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [gems_balance_by_day_no]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_gems_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_gems_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_gems_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_gems_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_gems_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                        </nz-collapse>
                    </nz-collapse-panel>

                    <!-- HINTS -->
                    <nz-collapse-panel
                        nzHeader="Hints"
                        [nzActive]="!isSectionCollapsed('hints')"
                        (nzActiveChange)="
                            onSectionActiveChange('hints', $event)
                        "
                    >
                        <nz-collapse>
                            <nz-collapse-panel
                                [nzHeader]="'Hints inflow'"
                                [nzActive]="!isSectionCollapsed('hints.inflow')"
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'hints.inflow',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [hints_inflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [hints_inflow_by_day_no]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_hints_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_hints_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_hints_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_hints_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_hints_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Hints outflow'"
                                [nzActive]="
                                    !isSectionCollapsed('hints.outflow')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'hints.outflow',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [hints_outflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                hints_outflow_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_hints_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_hints_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_hints_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_hints_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_hints_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Hints balance'"
                                [nzActive]="
                                    !isSectionCollapsed('hints.balance')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'hints.balance',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [hints_balance]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                hints_balance_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_hints_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_hints_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_hints_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_hints_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_hints_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                        </nz-collapse>
                    </nz-collapse-panel>

                    <!-- COINS -->
                    <nz-collapse-panel
                        nzHeader="Coins"
                        [nzActive]="!isSectionCollapsed('coins')"
                        (nzActiveChange)="
                            onSectionActiveChange('coins', $event)
                        "
                    >
                        <nz-collapse>
                            <nz-collapse-panel
                                [nzHeader]="'Coins inflow'"
                                [nzActive]="!isSectionCollapsed('coins.inflow')"
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'coins.inflow',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [coins_inflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [coins_inflow_by_day_no]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_coins_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_coins_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_coins_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_coins_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_coins_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Coins outflow'"
                                [nzActive]="
                                    !isSectionCollapsed('coins.outflow')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'coins.outflow',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [coins_outflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                coins_outflow_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_coins_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_coins_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_coins_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_coins_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_coins_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Coins balance'"
                                [nzActive]="
                                    !isSectionCollapsed('coins.balance')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'coins.balance',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [coins_balance]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                coins_balance_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_coins_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_coins_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_coins_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_coins_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_coins_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                        </nz-collapse>
                    </nz-collapse-panel>

                    <!-- COMPASSES -->
                    <nz-collapse-panel
                        nzHeader="Compasses"
                        [nzActive]="!isSectionCollapsed('compasses')"
                        (nzActiveChange)="
                            onSectionActiveChange('compasses', $event)
                        "
                    >
                        <nz-collapse>
                            <nz-collapse-panel
                                [nzHeader]="'Compasses inflow'"
                                [nzActive]="
                                    !isSectionCollapsed('compasses.inflow')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'compasses.inflow',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [compasses_inflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                compasses_inflow_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_compasses_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_compasses_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_compasses_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_compasses_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_compasses_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Compasses outflow'"
                                [nzActive]="
                                    !isSectionCollapsed('compasses.outflow')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'compasses.outflow',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [compasses_outflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                compasses_outflow_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_compasses_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_compasses_outflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_compasses_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_compasses_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_compasses_outflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'Compasses balance'"
                                [nzActive]="
                                    !isSectionCollapsed('compasses.balance')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'compasses.balance',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [compasses_balance]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                compasses_balance_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_compasses_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_compasses_balance_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_compasses_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_compasses_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_compasses_balance_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                        </nz-collapse>
                    </nz-collapse-panel>

                    <!-- DECORATIONS -->
                    <nz-collapse-panel
                        nzHeader="Decorations"
                        [nzActive]="!isSectionCollapsed('decorations')"
                        (nzActiveChange)="
                            onSectionActiveChange('decorations', $event)
                        "
                    >
                        <nz-collapse>
                            <nz-collapse-panel
                                [nzHeader]="'Decoration inflow'"
                                [nzActive]="
                                    !isSectionCollapsed('decorations.inflow')
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'decorations.inflow',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [decoration_inflow]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                decoration_inflow_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_decoration_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_decoration_inflow_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_decoration_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_decoration_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_decoration_inflow_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                            <nz-collapse-panel
                                [nzHeader]="'New decos placed'"
                                [nzActive]="
                                    !isSectionCollapsed(
                                        'decorations.new_placed'
                                    )
                                "
                                (nzActiveChange)="
                                    onSectionActiveChange(
                                        'decorations.new_placed',
                                        $event
                                    )
                                "
                            >
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="24"
                                        *ngFor="let link of [new_decos_placed]"
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                new_decos_placed_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                avg_new_decos_placed_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_new_decos_placed_per_active_user,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                                <div nz-row [nzGutter]="5">
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                median_new_decos_placed_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_avg_new_decos_placed_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                    <div
                                        nz-col
                                        nzSpan="8"
                                        *ngFor="
                                            let link of [
                                                running_median_new_decos_placed_per_user_by_day_no,
                                            ]
                                        "
                                    >
                                        <app-echarts-dashboard-item
                                            [dashboardItemFactory]="
                                                link.dashboardItemFactory
                                            "
                                            [dataLoaderEmitter]="
                                                link.dataLoaderEmitter
                                            "
                                        ></app-echarts-dashboard-item>
                                    </div>
                                </div>
                            </nz-collapse-panel>
                        </nz-collapse>
                    </nz-collapse-panel>
                </nz-collapse>
            </div>
        </div>
    </nz-content>
</nz-layout>
